import React, { Component } from 'react';
import shortID from 'short-id-gen';
import Select from '../form/Select';
import { InputGroup } from '@blueprintjs/core';
import { Row, Column as Col } from 'hedron';
import Modal from './Modal';

const initialState = {
  name: null,
  description: null,
  template: null,
  templateData: {},
  createdAt: null,
  lastModified: null,
}

const templates = {
  fullscreenImage: {
    requiredFields: {
      image: {
        type: 'image',
        placeholder: 'ID der Bildes',
      },
      duration: {
        type: 'number',
        placeholder: 'Angabe in Sekunden',
      },
    },
    optionalFields: {},
  },
  fullscreenVideo: {
    requiredFields: {
      video: {
        type: 'video',
        placeholder: 'ID des Videos',
      }
    }
  }
}

class NewSlideModal extends Modal {

  constructor(props) {
    super(props);

    this.state = { ...initialState };

    this.receiveSlideListener = this.receiveSlideListener.bind(this);
    this.getImageOptions = this.getImageOptions.bind(this);
    this.getVideoOptions = this.getVideoOptions.bind(this);

    this.title = props.slideID && props.slideID !== 'new' ? `Slide (ID: ${props.slideID})` : 'Neue Slide';
    this.iconName = "layers";
    this.initialState = initialState;
  }

  onComponentWillMount() {
    if (this.props.slideID && this.props.slideID !== 'new') {
      this.props.database.ref(`slides/${this.props.slideID}`).on('value', this.receiveSlideListener);
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.slideID !== this.props.slideID) {
      this.setState(initialState);

      if (this.props.slideID && this.props.slideID !== 'new') {
        this.props.database.ref(`slides/${this.props.slideID}`).off('value', this.receiveSlideListener);
      }
      if (newProps.slideID && newProps.slideID !== 'new') {
        this.props.database.ref(`slides/${newProps.slideID}`).on('value', this.receiveSlideListener);
      }
    }
  }

  onComponentWillUnmount() {
    if (this.props.slideID && this.props.slideID !== 'new') {
      this.props.database.ref(`slides/${this.props.slideID}`).off('value', this.receiveSlideListener);
    }
  }

  getImageOptions() {
    const images = [];
    for (let key in this.props.images) {
      if (!this.props.images.hasOwnProperty(key)) continue;
      const image = this.props.images[key];
      images.push(
        { value: key, label: image.name }
      );
    }
    return images;
  }

  getVideoOptions() {
    const videos = [];
    for (let key in this.props.videos) {
      if (!this.props.videos.hasOwnProperty(key)) continue;
      const video = this.props.videos[key];
      videos.push(
        { value: key, label: video.name }
      );
    }
    return videos;
  }

  receiveSlideListener(snap) {
    const slide = snap.val()
    this.setState(slide);
  }

  save() {
    if (!this.state.name) {
      return;
    }

    let slideID = this.props.slideID;
    slideID = !slideID || slideID === 'new' ? shortID.generate(10) : slideID;

    this.props.database.ref(`slides/${slideID}`).set({
      customer: this.props.customerID,
      name: this.state.name,
      description: this.state.description,
      template: this.state.template,
      templateData: this.state.templateData,
      createdAt: this.state.createdAt || new Date(),
      lastModified: new Date(),
    });
    this.hide();
  }

  renderContentSetting(name, inputData) {
    switch (inputData.type) {
      case 'string': {
        return (
          <Col sm={6}>
            <label>
              {name.charAt(0).toUpperCase() + name.slice(1)}
              <InputGroup
                type="text"
                value={this.state.templateData[name] || ''}
                placeholder={this.state.templateData[name] || '' ? null : inputData.placeholder}
                onChange={(e) => {
                  const newContent = { ...this.state.templateData };
                  newContent[name] = e.target.value;
                  this.setState({ templateData: newContent });
                }}
              />
            </label>
          </Col>
        );
      }
      case 'number': {
        return (
          <Col sm={6}>
            <label>
              {name.charAt(0).toUpperCase() + name.slice(1)}
              <InputGroup
                type="number"
                value={`${this.state.templateData[name] || ''}`}
                placeholder={!this.state.templateData[name] || '' ? null : inputData.placeholder}
                onChange={(e) => {
                  const newContent = { ...this.state.templateData };
                  newContent[name] = Number(e.target.value);
                  this.setState({ templateData: newContent });
                }}
              />
            </label>
          </Col>
        );
      }
      case 'image': {
        return (
          <Select
            label={name.charAt(0).toUpperCase() + name.slice(1)}
            controlId={`formSlideContent${name.charAt(0).toUpperCase() + name.slice(1)}`}
            validationState={null}
            sm={6}
            placeholder="Bild wählen"
            options={this.getImageOptions()}
            value={this.state.templateData[name]}
            onChange={(e) => {
              const newContent = { ...this.state.templateData };
              newContent[name] = e.target.value;
              this.setState({ templateData: newContent });
            }}
          />
        )
      }
      case 'video': {
        return (
          <Select
            label={name.charAt(0).toUpperCase() + name.slice(1)}
            controlId={`formSlideContent${name.charAt(0).toUpperCase() + name.slice(1)}`}
            validationState={null}
            sm={12}
            placeholder="Video wählen"
            options={this.getVideoOptions()}
            value={this.state.templateData[name]}
            onChange={(e) => {
              const newContent = { ...this.state.templateData };
              newContent[name] = e.target.value;
              this.setState({ templateData: newContent });
            }}
          />
        )
      }
      default: {
        return null;
      }
    }
  }

  renderContentSettings() {
    const template = templates[this.state.template];
    if (!template) {
      return null;
    }

    const settings = [];
    for (let key in template.requiredFields) {
      if (!template.requiredFields.hasOwnProperty(key)) continue;
      settings.push(
        this.renderContentSetting(key, template.requiredFields[key])
      );
    }
    return settings;
  }

  renderTemplateOptions() {
    const options = [
      <option value="" key="slideTemplate_default">Bitte wählen</option>
    ];
    for (let key in templates) {
      if (!templates.hasOwnProperty(key)) continue;
      options.push(
        <option
          value={key}
          key={`slideTemplate_${key}`}
        >
          {key}
        </option>
      );
    }
    return options;
  }

  renderBody() {
    return (
      <div>
        <Row>
          <Col sm={6}>
            <label>
              Name
              <InputGroup
                type="text"
                value={this.state.name || ''}
                placeholder={this.state.name ? null : 'Name der Slide'}
                onChange={(e) => this.setState({ name: e.target.value })}
              />
            </label>
          </Col>
          <Col sm={6}>
            <label>
              Beschreibung
              <InputGroup
                type="text"
                value={this.state.description || ''}
                placeholder="Beschreibung der Slide"
                onChange={(e) => this.setState({ description: e.target.value })}
              />
            </label>
          </Col>
          <Col sm={6}>
            <label>
              Template
              <select
                componentClass="select"
                placeholder="select"
                value={this.state.template || ''}
                onChange={(e) => this.setState({ template: e.target.value, templateData: {} })}
              >
                {this.renderTemplateOptions()}
              </select>
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={12}><h3>Content</h3></Col>
          {this.renderContentSettings()}
        </Row>
      </div>
    );
  }
}

export default NewSlideModal;



/** WEBPACK FOOTER **
 ** ./src/modals/SlideModal.js
 **/